import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../../../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../../../../colors-v2';
import { shadows } from '../../../../../shadows';
import { ExerciseShortAnswerOptions } from '../../types';
import { DoTestActions } from './DoTestActions';

/* eslint-disable no-nested-ternary */
type DoTestExerciseShortAnswerQuestionsProps = RenderElementProps &
  Pick<ExerciseShortAnswerOptions, 'onBackWhenInComplete'>;

const Main = styled.div`
  padding: 12px;
  background: ${colorsV2.white100};
  border: 1px solid ${colorsV2.gray40};
  box-shadow: ${shadows.zIndex3};
  border-radius: 8px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 16px;
  .do-test-wrapper {
    margin-top: 8px;
  }
  @media ${deviceBreakpoints.fromTablet} {
    padding: 24px;
    gap: 24px;
    margin-top: 24px;
  }
`;

export const DoTestExerciseShortAnswerQuestions = observer(
  (props: DoTestExerciseShortAnswerQuestionsProps) => {
    const { attributes, children } = props;
    return (
      <Main className="do-test-exercise-short-answer-questions" {...attributes}>
        {children}
        <div className="do-test-wrapper">
          <DoTestActions {...props} />
        </div>
      </Main>
    );
  }
);
